import { Deployment } from "./PublishProject/types";

import "./DeploymentCard.scss";

interface IProps {
  deployment: Deployment;
}

const DeploymentCard = ({ deployment }: IProps) => {
  let color = "green";
  if (deployment.age > 28) {
    color = "red";
  } else if (deployment.age > 14) {
    color = "yellow";
  } else if (deployment.age < 0) {
    color = "pink";
  }

  return (
    <div className={`deployment status-${color}`}>
      <div className="deployment-top">{deployment.name}</div>
      <div className={`card-divider status-${color}`}></div>
      <div className="deployment-bottom">{deployment.version}</div>
    </div>
  );
};

export default DeploymentCard;
